module.exports = __webpack_public_path__ + "img/diesel .2caf5795.png";